import { render, staticRenderFns } from "./TabFindvillas.vue?vue&type=template&id=2d6e719c&"
import script from "./TabFindvillas.vue?vue&type=script&lang=js&"
export * from "./TabFindvillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports